import { Component, OnInit } from '@angular/core';
import { CommonApiService } from '../CommonController/common-api-service';
import { ProductionDeviceApiService } from '../CommonController/production-device-api-service';

import { HttpErrorResponse } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker';
import {
  MatError,
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedValidators } from '../shared/validators/shared-validators';
import { DeviceModelApiService } from '../CommonController/device-model-api-service';
import { MatOption, MatSelect } from '@angular/material/select';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-production-device-add-page',
  templateUrl: './production-device-add-page.component.html',
  styleUrls: ['./production-device-add-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatSelect,
    MatOption,
  ],
})
export class ProductionDeviceAddPageComponent implements OnInit {
  uid = '';
  ProductionDeviceAddForm!: FormGroup;

  userPermission = [];
  loggedId = '';
  ProductionDeviceCreate = true;
  ProductionDeviceUpdate = true;
  modelList: any[] = [];

  projectName = environment.projectName;

  constructor(
    public productionDeviceApiService: ProductionDeviceApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public deviceModelApiService: DeviceModelApiService
  ) {}

  ngOnInit(): void {
    this.uid = this.route.snapshot.paramMap.get('id') || '';
    this.fetchModelList();
    this.checkPermission();
    this.setProductionDeviceAddForm();
    if (this.uid) {
      this.ProductionDeviceUpdate = true;
      this.ProductionDeviceCreate = false;
      this.prepopulation(this.uid);
    } else {
      this.ProductionDeviceUpdate = false;
      this.ProductionDeviceCreate = true;
    }
  }

  checkPermission() {
    this.loggedId = sessionStorage.getItem('loggedInUserId') || '';
    this.userPermission = JSON.parse(
      sessionStorage.getItem('userPermissions') || '[]'
    );
    if (this.uid !== null) {
      this.userPermission.forEach((element: any) => {
        if (element.pageName === 'Production Device') {
          if (element.update === false) {
            this.navigateBack();
          }
        }
      });
    } else {
      this.userPermission.forEach((element: any) => {
        if (element.pageName === 'Production Device') {
          if (element.create === false) {
            this.navigateBack();
          }
        }
      });
    }
  }

  setProductionDeviceAddForm() {
    this.ProductionDeviceAddForm = this.fb.group({
      uid: new FormControl('', [
        SharedValidators.lengthCheckValidator(19, {
          noSpecialChars: true,
          required: true,
        }),
      ]),
      imei: new FormControl('', [
        SharedValidators.lengthCheckValidator(15, {
          onlyNumbers: true,
          required: true,
        }),
      ]),
      iccid: new FormControl('', [
        SharedValidators.lengthCheckValidator(20, {
          noSpecialChars: true,
          required: true,
        }),
      ]),
      modelName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      mobile: new FormControl('', [
        SharedValidators.lengthCheckValidator(15, {
          onlyNumbers: true,
          required: true,
        }),
      ]),
      serviceProvider: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
      altMobile: new FormControl('', [
        SharedValidators.lengthCheckValidator(15, { onlyNumbers: true }),
      ]),
      altServiceProvider: new FormControl(''),
      // simVendor: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      firmware: new FormControl(
        '',
        this.projectName === 'Sampark'
          ? SharedValidators.requiredAndNoEmptySpaces
          : []
      ),
      openCpuVersion: new FormControl(''),
      mcuVersion: new FormControl(''),
      bootVersion: new FormControl(''),
      gpsVersion: new FormControl(''),
      gsmVersion: new FormControl(''),
      sdkVersion: new FormControl(''),
      bootstrapExpDate: new FormControl('', SharedValidators.isValidDate),
      userId: new FormControl(
        this.loggedId,
        SharedValidators.requiredAndNoEmptySpaces
      ),
    });
    // code for altMobile no and alternate service provider cross validations
    this.ProductionDeviceAddForm.get('altMobile')!.valueChanges.subscribe(
      (mobileValue) => {
        const serviceProviderControl =
          this.ProductionDeviceAddForm.get('altServiceProvider');
        if (mobileValue) {
          serviceProviderControl!.setValidators([
            SharedValidators.requiredAndNoEmptySpaces,
          ]);
        } else {
          serviceProviderControl!.clearValidators();
        }
        serviceProviderControl!.updateValueAndValidity({ emitEvent: false });
      }
    );

    this.ProductionDeviceAddForm.get(
      'altServiceProvider'
    )!.valueChanges.subscribe((providerValue) => {
      const mobileControl = this.ProductionDeviceAddForm.get('altMobile');
      if (providerValue) {
        mobileControl!.setValidators([
          SharedValidators.lengthCheckValidator(15, { onlyNumbers: true }),
        ]);
      } else {
        mobileControl!.clearValidators();
      }
      mobileControl!.updateValueAndValidity({ emitEvent: false });
    });
  }

  // Custom date format validator to check "YYYY-MM-DD"
  dateFormatValidator(control: FormControl) {
    const isValid = moment(control.value, 'YYYY-MM-DD', true).isValid();
    return isValid ? null : { invalidDateFormat: true };
  }

  // Utility function to convert Excel date serial number to "YYYY-MM-DD" format
  convertExcelDate(serialStr: string) {
    const serial = parseInt(serialStr, 10); // Convert string to number
    const baseDate = new Date(1900, 0, 1); // Base date is "1900-01-01"
    const correctedSerial = serial - 1; // Excel serial date starts from day 1, so subtract 1
    const calculatedDate = new Date(
      baseDate.getTime() + correctedSerial * 86400000
    ); // Add days in milliseconds
    return moment(calculatedDate).format('YYYY-MM-DD'); // Format to "YYYY-MM-DD"
  }

  formatToYYYYMMDD(date: string | Date) {
    if (!date) return '';

    const d = new Date(date);
    if (isNaN(d.getTime())) {
      // Return the original value as a string if the date is invalid
      return String(date);
    }

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  addModelFormGroup(): FormGroup {
    return this.fb.group({
      releaseDate: [''],
      file: [''],
      firmwareVersion: [''],
    });
  }

  prepopulation(uid: string) {
    this.spinner.show();
    this.productionDeviceApiService
      .getProductionDeviceById(uid)
      .subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          const data = res.data;
          this.ProductionDeviceAddForm = this.fb.group({
            uid: new FormControl(data.uid, [
              SharedValidators.lengthCheckValidator(19, {
                noSpecialChars: true,
              }),
            ]),
            imei: new FormControl(data.imei, [
              SharedValidators.lengthCheckValidator(15, { onlyNumbers: true }),
            ]),
            iccid: new FormControl(data.iccid, [
              SharedValidators.lengthCheckValidator(20, {
                noSpecialChars: true,
              }),
            ]),
            modelName: new FormControl(data.modelName, [
              SharedValidators.requiredAndNoEmptySpaces,
            ]),
            mobile: new FormControl(data.mobile, [
              SharedValidators.lengthCheckValidator(15, {
                onlyNumbers: true,
                required: true,
              }),
            ]),
            serviceProvider: new FormControl(data.serviceProvider, [
              SharedValidators.requiredAndNoEmptySpaces,
            ]),
            altMobile: new FormControl(data.altMobile, [
              SharedValidators.lengthCheckValidator(15, { onlyNumbers: true }),
            ]),
            altServiceProvider: new FormControl(data.altServiceProvider),
            bootstrapExpDate: new FormControl(data.bootstrapExpDate),
            // simVendor: new FormControl(data.simVendor, [
            //   SharedValidators.requiredAndNoEmptySpaces,
            // ]),
            firmware: new FormControl(
              data.firmwareVersion,
              this.projectName === 'Sampark'
                ? [SharedValidators.requiredAndNoEmptySpaces]
                : []
            ),
            openCpuVersion: new FormControl(data.openCpuVersion),
            mcuVersion: new FormControl(data.mcuVersion),
            bootVersion: new FormControl(data.bootVersion),
            gpsVersion: new FormControl(data.gpsVersion),
            gsmVersion: new FormControl(data.gsmVersion),
            sdkVersion: new FormControl(data.sdkVersion),
            BootstrapExpDate: new FormControl(
              data.bootstrapExpDate && /^\d+$/.test(data.bootstrapExpDate)
                ? this.convertExcelDate(data.bootstrapExpDate)
                : this.formatToYYYYMMDD(String(data.bootstrapExpDate))
            ),
            userId: new FormControl(
              this.loggedId,
              SharedValidators.requiredAndNoEmptySpaces
            ),
          });
        } else {
          console.error('API Response error:', res.message);
        }
      });
  }

  fetchModelList() {
    this.spinner.show();
    this.deviceModelApiService.getDeviceModelList(1, 100000, '').subscribe(
      (res) => {
        this.modelList = res.data;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        if (error.status === 404) {
          this.modelList = [];
        } else {
          this.commonApiService.openSnackbar(
            'An error occurred while fetching device model data.'
          );
        }
      }
    );
  }

  validateFormUpdate() {
    if (this.ProductionDeviceAddForm.invalid) {
      SharedValidators.markAllAsTouched(this.ProductionDeviceAddForm);
      return;
    } else {
      this.updateData();
    }
  }
  validateFormSave() {
    if (this.ProductionDeviceAddForm.invalid) {
      SharedValidators.markAllAsTouched(this.ProductionDeviceAddForm);
      return;
    } else {
      this.saveData();
    }
  }

  saveData() {
    const payload = this.ProductionDeviceAddForm.value;
    payload.createdAt = Date.now();
    console.log('Payload to be sent:', payload);
    this.spinner.show();
    this.productionDeviceApiService.saveProductionData(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.router.navigate(['production-device-page']);
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  updateData() {
    this.spinner.show();
    const payload = this.ProductionDeviceAddForm.value;
    payload.id = this.uid;
    payload.updatedAt = Date.now();
    this.productionDeviceApiService
      .updateProductionDeviceData(payload)
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            this.redirect('production-device-page');
            this.ProductionDeviceUpdate = false;
            this.ProductionDeviceCreate = true;
            this.commonApiService.openSnackbar(res.message);
          } else {
            this.commonApiService.openSnackbar(res.message);
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(ERROR.error.message);
        },
      });
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
